import { Callback, TableParams } from '../types';

export type GetTimesheetByIdPayload = {
  id: string;
};

export type DeleteDailyTimesheetByIdPayload = {
  dailyTimesheetId: string;
  weeklyTimesheetId: string;
};

export type GetTimesheetsParams = TableParams;
export type GetDailyTimesheetAudit = { uri: string; callback: Callback };

export type TimesheetStatus = 'Submitted' | 'Open';
export type TimesheetModalType = 'EDIT' | 'ADD' | false | null;
export const TimesheetModalTypes = {
  ADD: 'ADD',
  EDIT: 'EDIT',
};
export type Timesheet = {
  id: string;
  employeeId: string;
  employeeName: string;
  startDate: string;
  trade: string;
  level: string;
  totalHours: number;
  regularHours: number;
  overtimeHours: number;
  rate: number;
  status: TimesheetStatus;
};

export type TimesheetDetail = {
  id: string;
  name: string;
  department: string;
  type: string;
  account: {
    id: string;
    name: string;
  };
  entityId: string;
  doingBusinessAs: string;
  timesheetId: string;
  status: string;
};

export type JobItem = {
  job?: number;
  task: string;
  lots: string;
  hours: number;
  phaseCode?: number;
  isExtra: boolean;
  jobOptions?: {}[];
  phaseOptions?: {}[];
};

export type DailyTimesheet = {
  id?: string;
  date: string;
  isNotWorking?: boolean;
  isNoLunch: boolean;
  startTime: Date | null;
  endTime: Date | null;
  commentOther?: string;
  comments?: string[];
  jobs: JobItem[];
  auditHistoryUri?: string;
  updatedDate?: string;
  createdDate?: string;
  totalHours?: number;
};

export type WeeklyTimesheet = {
  id?: string;
  startDate: string;
  endDate: string;
  employeeInfo: EmployeeInfo;
  dailyTimes?: DailyTimesheet[];
  regularHours?: number;
  overtimeHours?: number;
  status?: string;
};

export type EmployeeInfo = {
  id: string;
  employeeId: string;
  name: string;
  trade: string;
  rate: string;
  level: string;
};
export type TimesheetTableItem = {
  id?: string;
  startDate: string;
  employeeId: string;
  employeeLastName: string;
  status: string;
  trade: string;
  rate: string;
  level: string;
  regularHours?: number;
  overtimeHours?: number;
};
export type DetailItem = {
  jobCodeId: number;
  phaseCodeId: number;
  task: string;
  lot: string;
  isExtra: boolean;
  hours: number;
};

export type DailyTimesheetPayload = {
  date: string;
  startTime?: string;
  endTime?: string;
  isNotWorkedToday: boolean;
  isHavingLunch?: boolean;
  comment: string[];
  detail?: DetailItem[];
};

export type WeeklyTimesheetPayload = {
  employeeId: string;
  dailyTimesheets: DailyTimesheetPayload[];
  startDate: string;
  endDate: string;
};

export type AddDailyTimesheetsPayload = {
  id: string;
  dailyTimesheets: DailyTimesheetPayload[];
};

export type AuditHistory = {
  creator?: { firstName: string; lastName: string; role: string; createdDate: string };
  updater?: { firstName: string; lastName: string; role: string; updatedDate: string };
};
